// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"5231":"8269c4f474e2cfbf","46615":"3e2a1495525ba591","61745":"d0b91ec7c8af7026","72819":"9f4474e36c918f29","85682":"58f7f7042c8d4d77","96583":"d886093bc3588936"}[chunkId] + ".css";
};